// Auto-generated by processing/generateTypeMetadata.py from drool/type-metadata.csv — do not edit.
import { Type } from './sim/Enums';

export interface TypeInfo {
  bgColor: string;
  textColor: string;
  abbreviation: string;
  name: string;
  character: string;
}

// Real types only (excludes the Type.None single-type sentinel).
type RealType = Exclude<Type, Type.None>;

export const typeData: { [key in RealType]: TypeInfo } = {
  [Type.Yin]: { bgColor: '#111', textColor: '#eee', abbreviation: 'YIN', name: 'Yin', character: '陰' },
  [Type.Yang]: { bgColor: '#eee', textColor: '#111', abbreviation: 'YAN', name: 'Yang', character: '陽' },
  [Type.Earth]: { bgColor: '#8B4513', textColor: '#eee', abbreviation: 'ETH', name: 'Earth', character: '土' },
  [Type.Liquid]: { bgColor: '#1E90FF', textColor: '#111', abbreviation: 'LIQ', name: 'Liquid', character: '水' },
  [Type.Fire]: { bgColor: '#d2400a', textColor: '#eee', abbreviation: 'FIR', name: 'Fire', character: '火' },
  [Type.Metal]: { bgColor: '#60676b', textColor: '#eee', abbreviation: 'MTL', name: 'Metal', character: '金' },
  [Type.Ice]: { bgColor: '#4682B4', textColor: '#eee', abbreviation: 'ICE', name: 'Ice', character: '氷' },
  [Type.Nature]: { bgColor: '#228B22', textColor: '#eee', abbreviation: 'NTR', name: 'Nature', character: '木' },
  [Type.Lightning]: { bgColor: 'var(--text-warm)', textColor: '#111', abbreviation: 'LTG', name: 'Lightning', character: '雷' },
  [Type.Faith]: { bgColor: '#e39eab', textColor: '#111', abbreviation: 'FAI', name: 'Faith', character: '信' },
  [Type.Air]: { bgColor: '#7278b5', textColor: '#eee', abbreviation: 'AIR', name: 'Air', character: '氣' },
  [Type.Math]: { bgColor: '#aa2e70ff', textColor: '#eee', abbreviation: 'MTH', name: 'Math', character: '數' },
  [Type.Cyber]: { bgColor: '#00CED1', textColor: '#111', abbreviation: 'CYB', name: 'Cyber', character: '量' },
  [Type.Cosmic]: { bgColor: '#4B0082', textColor: '#eee', abbreviation: 'CMC', name: 'Cosmic', character: '混' },
} as const;
